var _excluded = ["label"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useId, useContext, useState } from 'react';
import isEqual from 'react-fast-compare';
import { classNames } from '../../../../../../utilities/css.js';
import { NavigationContext } from '../../../../context.js';
import styles from '../../../../Navigation.scss.js';
import { Collapsible } from '../../../../../Collapsible/Collapsible.js';
function SecondaryNavigation(_ref) {
  var ItemComponent = _ref.ItemComponent,
    icon = _ref.icon,
    longestMatch = _ref.longestMatch,
    subNavigationItems = _ref.subNavigationItems,
    showExpanded = _ref.showExpanded,
    truncateText = _ref.truncateText,
    secondaryNavigationId = _ref.secondaryNavigationId;
  var uid = useId();
  var _useContext = useContext(NavigationContext),
    onNavigationDismiss = _useContext.onNavigationDismiss;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    hoveredItem = _useState2[0],
    setHoveredItem = _useState2[1];
  var matchedItemPosition = subNavigationItems.findIndex(function (item) {
    return isEqual(item, longestMatch);
  });
  var hoveredItemPosition = subNavigationItems.findIndex(function (item) {
    return isEqual(item, hoveredItem);
  });
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.SecondaryNavigation, showExpanded && styles.SecondaryNavigationOpen, !icon && styles['SecondaryNavigation-noIcon'])
  }, /*#__PURE__*/React.createElement(Collapsible, {
    id: secondaryNavigationId || uid,
    open: showExpanded,
    transition: false
  }, /*#__PURE__*/React.createElement("ul", {
    className: styles.List
  }, subNavigationItems.map(function (item, index) {
    var label = item.label,
      rest = _objectWithoutProperties(item, _excluded);
    var onClick = function onClick() {
      onNavigationDismiss === null || onNavigationDismiss === void 0 || onNavigationDismiss();
      if (item.onClick && item.onClick !== onNavigationDismiss) {
        item.onClick();
      }
    };
    var shouldShowVerticalLine = index < matchedItemPosition;
    return /*#__PURE__*/React.createElement(ItemComponent, Object.assign({
      key: label
    }, rest, {
      label: label,
      showVerticalLine: shouldShowVerticalLine,
      showVerticalHoverPointer: index === hoveredItemPosition,
      onMouseEnter: item.disabled ? undefined : function () {
        return setHoveredItem(item);
      },
      onMouseLeave: item.disabled ? undefined : function () {
        return setHoveredItem(undefined);
      },
      matches: isEqual(item, longestMatch),
      onClick: onClick,
      truncateText: truncateText
    }));
  }))));
}
export { SecondaryNavigation };